import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [
	{ title: 'Emergency Preparedness' },
	{
		name: 'description',
		content: 'How to prepare for an emergency.',
	},
]

export default function Component() {
	return (
		<>
			<h1 className="py-3 text-4xl font-black">Emergency Preparedness</h1>
			<h3> Bug Out Bags </h3>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				In the event of an emergency or natural disaster, it may be necessary to
				evacuate your home for an extended period of time. It is strongly
				suggested that you create some family emergency procedures and plan
				ahead. Many people prepare by assembling the materials needed to sustain
				life for 72 hours. This is commonly referred to as a bug out bag, go
				bag, or 72 hour kit. This bag should be easily accessible to grab at a
				moment's notice if the need to evacuate should arise. Contents of your
				bug out bag might include:
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<ul>
					<li>
						Food - MREs have a good shelf life. You may want a spork, knife,
						cup, can opener, camp stove, etc. Be sure to check your food supply
						regularly. Use the food before it goes bad, and replace it with new
						food.
					</li>
					<li>
						Water - The suggested minimum amount of drinking water is 1 liter
						per person per day. You should include a refillable water bottle in
						your bag.
					</li>

					<li>
						Clothing - You should have a couple of complete changes of clothes,
						including underwear and socks. Work gloves are a helpful addition,
						as is a hat. A poncho can keep you dry and alive. If you have kids,
						make sure that you are keeping their current size of clothing in
						your bags.
					</li>
					<li> First Aid Kit</li>
					<li> NOAA Radio</li>
					<li> Diapers and wipes for the kids</li>
					<li> Feminine hygiene products</li>
					<li> Lighting - flashlight with batteries, candles, etc.</li>
					<li> Heat source - matches</li>
					<li> Emergency blanket</li>
					<li>
						{' '}
						Phone Charger with power bank - power banks can be purchased for
						under $20 and can keep your cell phone charged for minimal use over
						a few days.
					</li>
					<li>Cash in smaller bills</li>
					<li>Area map & compass</li>
					<li>Paper and pencil</li>
					<li>
						Copies of important documents - insurance policies, birth
						certificates, etc.
					</li>
					<li>Prescription Medication</li>
				</ul>
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Here are some things to remember before leaving home in an evacuation
				situation:
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Know where the water and gas shutoffs are in your home and, if time
				permits, shut them off prior to evacuating. Grab your go bag and see
				that neighbors are okay.
			</p>
			<h3>Home Fire Drills</h3>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Every family should conduct home fire drills at least annually. October
				15th is National Home Fire Drill day and a good choice for a date
				because the weather tends to not be too cold and is shortly before the
				winter heating season begins.
			</p>
		</>
	)
}
